import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

@Component({
  selector: 'mtg-data-slider-item',
  template: '<ng-content></ng-content>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataSliderItemComponent {
  @HostBinding('class.data-slider-item')
  defaultClass = true;
}
